// initial state
const state = {
  viewingViaShareLink: false,
  shareLinkIsProductDetailPage: false
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  shareLinkIsProductDetailPageAssign (state, bool) {
    state.shareLinkIsProductDetailPage = bool
  },
  viewingViaShareLinkAssign (state, bool) {
    state.viewingViaShareLink = bool
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/js/store/modules/user.js